module.exports = __webpack_public_path__ + "static/media/bg-login.d922b6e9.png";